import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=4b5af144&scoped=true"
import script from "./PrimaryButton.vue?vue&type=script&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&lang=js"
import style0 from "./PrimaryButton.vue?vue&type=style&index=0&id=4b5af144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5af144",
  null
  
)

export default component.exports